export interface Client {
  name: string;
  industry: string;
  icon: string;
  image: string;
  initials: string;
  color: string;
}

export const clients: Client[] = [
  {
    name: 'IQVIA',
    industry: 'Healthcare & Pharma',
    icon: 'ri-hospital-line',
    image: 'src/images/clients/iqvia.png',
    initials: 'IQVIA',
    color: 'bg-emerald-50 text-emerald-600 border-emerald-200',
  },
  {
    name: 'EGO Pharmaceuticals',
    industry: 'Banking & Finance',
    icon: 'ri-bank-line',
    image: 'src/images/clients/ego-pharma.png',
    initials: 'EGP',
    color: 'bg-amber-50 text-amber-600 border-amber-200',
  },
    {
    name: 'Fortune Consultancy',
    industry: 'Recruitment, Staffing',
    icon: 'ri-smartphone-line',
    image: 'src/images/clients/fortune-consultancy.png',
    initials: 'NN',
    color: 'bg-red-50 text-red-600 border-red-200',
  },
  {
    name: 'Data Foundation Labs',
    industry: 'Data Engineering',
    icon: 'ri-shield-check-line',
    image: 'src/images/clients/DF-Labs.png',
    initials: 'SI',
    color: 'bg-teal-50 text-teal-600 border-teal-200',
  },
  {
    name: 'Rythugaru',
    industry: 'AgriTech, SaaS & Product',
    icon: 'ri-apps-line',
    image: 'src/images/clients/rythugaru.png',
    initials: 'Rythugaru',
    color: 'bg-primary-50 text-primary-600 border-primary-200',
  },
  {
    name: 'SSA Systems',
    industry: 'Retail & E-commerce',
    icon: 'ri-shopping-cart-line',
    image: 'src/images/clients/ssa-systems.png',
    initials: 'SSA',
    color: 'bg-rose-50 text-rose-600 border-rose-200',
  },
  {
    name: 'SoCLogIC',
    industry: 'Logistics',
    icon: 'ri-truck-line',
    image: 'src/images/clients/soc.png',
    initials: 'SOC',
    color: 'bg-yellow-50 text-yellow-600 border-yellow-200',
  },
  {
    name: 'zipme',
    industry: 'Manufacturing',
    icon: 'ri-tools-line',
    image: 'src/images/clients/zipme.png',
    initials: 'zipme',
    color: 'bg-orange-50 text-orange-600 border-orange-200',
  },
  {
    name: 'SAC',
    industry: 'AgriTech',
    icon: 'ri-graduation-cap-line',
    image: 'src/images/clients/sac.png',
    initials: 'SAC',
    color: 'bg-pink-50 text-pink-600 border-pink-200',
  },
  {
    name: 'oncluud',
    industry: 'SaaS & Product',
    icon: 'ri-plant-line',
    image: 'src/images/clients/oncluud.png',
    initials: 'GF',
    color: 'bg-lime-50 text-lime-600 border-lime-200',
  },

];